//import liraries
import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  Image,
  ScrollView,
  FlatList,
} from "react-native";
import QuickLinks from "../Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import { getAllVehiclesList, filterVehicle, getPoolAccountdetail, getPoolToTagTransfer, } from "./../../api/apiManager";
import { get, isEmpty } from "lodash";
import ModalAlert from "../../common/ModalAlert";
import RootNavigation from "../../utilities/RootNavigation";
import { useLocation } from "react-router-dom";
import useStyles from "./PoolSelectVehicles_Styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const PoolSelectVehicles = (props) => {
  const [value, setValue] = useState("1");
  const {state} = useLocation()
  const styles = useStyles();
 
  const [vehicleList, setVehicleList] = useState([]);
  const [data, setData] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState([]);
  const [selectedVrn, setSelectedVrn] = useState([]);
  const [targetVrn, setTargetVrn] = useState("");
  const [selectSingleVrn, setSelectSingleVrn] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [showCreditVehicle, setShowCreditVehicle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
const onCloseModal = () => {
    setAlertModalVisible(false);
    RootNavigation.navigate('Profile/PoolAccount')
   };

  useEffect(() => {
    getVehicleList();
    getPoolAccountDtls();
  }, []);
  const getVehicleList = () => {
    setLoading(true);
    getAllVehiclesList()
      .then((res) => {
        if (res && !isEmpty(res)) {

          setVehicleList(res.filter(item => item?.status == "Activated" || item?.status == "Low Balance" || item?.status =="Hotlisted"));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        });
  };

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setData(res || {});
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onConfirm = () => {
    // let newarr = selectedVehicle.map((item) => {
    //   return { toVrn: item, amount: state.amount };
    // });
    let newarr = selectedVehicleId.map((item) => {
      return { toVrn: item.vrn, tagId:item.id, amount: state.amount };
    });
    let params = {
      vrn: newarr,
    };
    getPoolToTagTransfer(params)
      .then((res) => {
        if (res.statusCode == 200) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        } else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message || "",
            navigateScreen: "PoolAccountScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message || "",
          navigateScreen: "PoolAccountScreen",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });

  };

  const vehicleSelelction = (params) => {

    if (state.value == "Pool To Tag") {

      if (selectedVehicle.includes(params?.toVrn?.vrn)) {
        let tempArr = [...selectedVehicle]
        let index = tempArr.indexOf(params?.toVrn?.vrn)
        if (index !== -1) {
          tempArr.splice(index, 1);
          setSelectedVehicle([...tempArr])
        }
        tempArr = selectedVehicleId.filter(obj => obj.vrn !== params?.toVrn?.vrn);
        setSelectedVehicleId(tempArr)

      } else {
        setSelectedVehicle([...selectedVehicle, params?.toVrn?.vrn]);
        setSelectedVehicleId([...selectedVehicleId, {vrn : params?.toVrn?.vrn, id: params?.toVrn?.fastagId}]);
      }

      if (selectedVrn.includes(params?.toVrn?.vrn)) {
        let tempArr = [...selectedVrn]
        let index = tempArr.indexOf(params?.toVrn?.vrn)
        if (index !== -1) {
          tempArr.splice(index, 1);
          setSelectedVrn([...tempArr])
        }

      } else {
        setSelectedVrn([...selectedVrn, params?.toVrn?.vrn]);
      }
    } else if (state.value == "Tag To Pool") {
      setSelectSingleVrn(params.toVrn);
    } else if (state.value == "Tag To Tag") {
      setSelectSingleVrn(params.toVrn);
    }
  };

  const disableButton = () => {
    if (state.value == "Pool To Tag" && selectedVehicle.length == 0) {
      return true;
    } else if (state.value == "Tag To Pool" && !selectSingleVrn) {
      return true;
    } else if (state.value == "Tag To Tag" && !selectSingleVrn) {
      return true;
    } else {
      return false;
    }
  };

  const vehicleSelelctionForCredit = (params) => {
    setTargetVrn(params.toVrn);
  };

  const renderTagToPoolTransferSummary = () => {
  
    let summaryObj = {
      value: state.value,
      vehicleModel: selectedVehicle,
      vrn: selectSingleVrn,
      target: targetVrn
    }
    RootNavigation.navigate('Profile/PoolAccount/transferSummary', summaryObj)
   
  };

  return showCreditVehicle ? (
    <View style={styles.mainContainer}>
      <View style={styles.viewStyle}>
        <View style={styles.backIconView}>
          <TouchableOpacity
            onPress={() => {
              setShowCreditVehicle(false);
            }}
          >
            <Image
              source={require("../../assets/images/back.png")}
              style={styles.backIcon}
            />
          </TouchableOpacity>

          <Text style={styles.textStyle}>{"Select Tag To Credit To"}</Text>
        </View>

        <View style={styles.customButtonView}>
          <CustomButton
            text="Transfer"
            onPress={
              !targetVrn
                ? ()=>{}
                : () => {
                  renderTagToPoolTransferSummary();
                }
            }
            disable={!targetVrn ? true : false}
          />
        </View>
      </View>
      {state.value == "Pool To Tag" ? (
        <View style={styles.selectAllView}>
          <Text style={styles.selectText}>
            Selected Vehicles({selectedVehicle.length})
          </Text>
          <TouchableOpacity
            onPress={() => {
              setSelectedVehicle([vehicleList?.vrn]);
              setSelectedVrn([vehicleList?.vrn]);
              setSelectedVehicleId([{vrn:vehicleList?.vrn, id:vehicleList?.fastagId}])
            }}
          >
            <Text style={styles.selectAll}>Select All</Text>
          </TouchableOpacity>
        </View>
      ) : null}

      <ScrollView
        showsHorizontalScrollIndicator={false}
        horizontal
        style={{
          marginBottom: -30,
          marginTop: state.value == "Pool To Tag" ? 0 : 20,
        }}
      >
        <FlatList
          extraData
          style={styles.flatListView}
          data={isEmpty(vehicleList) ? [] : vehicleList}
          key={Math.random().toString(36).substr(2, 5)}
          renderItem={({ item }) => {
            return (
              <View style={styles.imgContainer}>
                <View style={styles.firstContainer}>
                  <View style={styles.subView}>
                    <View style={{ marginVertical: 4 }}>
                      <Image
                        source={require("../../assets/images/car.png")}
                        style={styles.bitMap}
                      />
                    </View>

                    <View style={styles.hondaTextContainer}>
                      <Text style={styles.textStyle2}>{item?.vrn}</Text>
                      <Text style={styles.honda}>{item?.vehicleModel}</Text>
                    </View>

                    <View style={styles.numberContainer}>
                      <Text style={styles.number}>
                        {item?.fastagBalance.toString().includes(".") ? item?.fastagBalance.toFixed(2) : item?.fastagBalance + ".00"}
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          vehicleSelelctionForCredit({ toVrn: item });
                        }}
                        style={styles.radiobuttonOutSideStyle}
                      >
                        {targetVrn?.vrn == item.vrn ? (
                          <View style={styles.radioButtonInsideStyle} />
                        ) : null}
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            );
          }}
          numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
        />
      </ScrollView>
      <View style={styles.mobileCustomButtonStyle}>
        <CustomButton
          text="Transfer"
          onPress={
            !targetVrn
              ? ()=>{}
              : () => {
                renderTagToPoolTransferSummary();
              }
          }
          disable={!targetVrn ? true : false}

        />
      </View>
      <QuickLinks navigation={props.navigation} />
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  ) : (
    <View style={styles.mainContainer}>
      <View style={styles.viewStyle}>
        <View style={styles.backIconView}>
          <TouchableOpacity
            onPress={() => {
              console.log("ssdssss", state);
              RootNavigation.navigate(`Profile/PoolAccount/${state.value == "Pool To Tag" ? "PoolToTag" : "TransferPool"}`, {value: state.value })
             }}
          >
            <Image
              source={require("../../assets/images/back.png")}
              style={styles.backIcon}
            />
          </TouchableOpacity>

          <Text style={styles.textStyle}>
            {state.value == "Pool To Tag"
              ? "Pool to Tag Transfer"
              : "Select Tag To Debit From"}
          </Text>
        </View>

        <View style={styles.customButtonView}>
          <CustomButton
            text="Transfer"
            onPress={
              disableButton()
                ? null
                : state.value == "Pool To Tag"
                  ? () => {
                    onConfirm();
                  }
                  : state.value == "Tag To Pool"
                    ? () => {
                      renderTagToPoolTransferSummary();
                    }
                    : state.value == "Tag To Tag"
                      ? () => setShowCreditVehicle(true)
                      : null
            }
            disable={disableButton()}

          />
        </View>
      </View>
      {state.value == "Pool To Tag" ? (
        <View style={styles.selectAllView}>
          <Text style={styles.selectText}>
            Selected Vehicles({selectedVehicle.length})
          </Text>
          <TouchableOpacity
            onPress={() => {

              setSelectedVehicle(vehicleList.map(item => item.vrn));
              setSelectedVrn(vehicleList.map(item => item.vrn));
              setSelectedVehicleId(vehicleList.map(item => ({vrn: item.vrn, id:item.fastagId})))
            }}
          >
            <Text style={styles.selectAll}>Select All</Text>
          </TouchableOpacity>
        </View>
      ) : null}

      <ScrollView
        showsHorizontalScrollIndicator={false}
        horizontal
        style={{
          marginBottom: -30,
          marginTop: state.value == "Pool To Tag" ? 0 : 20,
        }}
      >
        <FlatList
          extraData
          style={styles.flatListView}
          data={isEmpty(vehicleList) ? [] : vehicleList}
          key={Math.random().toString(36).substr(2, 5)}
          renderItem={({ item }) => {
            return (
              <View style={styles.imgContainer}>
                <View style={styles.firstContainer}>
                  <View style={styles.subView}>
                    <View style={{ marginVertical: 4 }}>
                      <Image
                        source={require("../../assets/images/car.png")}
                        style={styles.bitMap}
                      />
                    </View>

                    <View style={styles.hondaTextContainer}>
                      <Text style={styles.textStyle2}>{item?.vrn}</Text>
                      <Text style={styles.honda}>{item?.vehicleModel}</Text>
                    </View>

                    <View style={styles.numberContainer}>
                      <Text style={styles.number}>
                        {item?.fastagBalance.toString().includes(".") ? item?.fastagBalance.toFixed(2) : item?.fastagBalance + ".00"}
                      </Text>
                      {
                        state.value == "Pool To Tag"
                          ? <TouchableOpacity
                            onPress={() => {
                              vehicleSelelction({ toVrn: item });
                            }}
                            style={[styles.radiobuttonOutSideStyle, { width: 15.9, height: 15.9, borderRadius: 3, borderColor: "#c3c3c3" }]}
                          >
                            {(
                              state.value == "Pool To Tag"
                                ? selectedVrn.includes(item.vrn) ||
                                selectedVrn.includes(vehicleList?.vrn)
                                : selectSingleVrn?.vrn == item.vrn
                            ) ? (
                            
                              <Image source={require("../../assets/images/check_active.png")} style={{ width: 15.9, height: 15.9 }} />
                            ) : null}
                          </TouchableOpacity>
                          : <TouchableOpacity
                            onPress={() => {
                              vehicleSelelction({ toVrn: item });
                            }}
                            style={styles.radiobuttonOutSideStyle}
                          >
                            {(
                              state.value == "Pool To Tag"
                                ? selectedVrn.includes(item.vrn) ||
                                selectedVrn.includes(vehicleList?.vrn)
                                : selectSingleVrn?.vrn == item.vrn
                            ) ? (
                              <View style={styles.radioButtonInsideStyle} />
                            ) : null}
                          </TouchableOpacity>
                      }
                    </View>
                  </View>
                </View>
              </View>
            );
          }}
          numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
        />
      </ScrollView>
      <View style={styles.mobileCustomButtonStyle}>
        <CustomButton
          text="Transfer"
          onPress={
            state.value == "Pool To Tag"
              ? () => {
                onConfirm();
              }
              : state.value == "Tag To Pool"
                ? () => {
                  renderTagToPoolTransferSummary();
                }
                : state.value == "Tag To Tag"
                  ? () => setShowCreditVehicle(true)
                  : null
          }
        />
      </View>
      <QuickLinks navigation={props.navigation} />
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
};
export default PoolSelectVehicles;
